import { createBrowserRouter } from "react-router-dom";

import { BareLayout } from "./routes/BareLayout";
import { LegacyEmbedRedirect } from "./routes/LegacyEmbedRedirect";
import { ReportPage } from "./routes/ReportPage";
import { ReportsIndexPage } from "./routes/ReportsIndexPage";
import { RequireAuth } from "./routes/RequireAuth";
import { RequireReportingRole } from "./routes/RequireReportingRole";
import { RootLayout } from "./routes/RootLayout";
import { NotFoundPage } from "./routes/NotFoundPage";

export const router = createBrowserRouter([
  {
    // Chrome-free pages meant to be iframed into Luna. Deliberately unguarded:
    // redirecting to the hub inside Luna's iframe would trap the user.
    element: <BareLayout />,
    children: [
      { path: "/embed/:slug", element: <ReportPage /> },
      // Retired name for the same route, kept one release so a cached Luna
      // bundle mid-rollout doesn't iframe a 404. See LegacyEmbedRedirect.
      { path: "/infusions/:slug", element: <LegacyEmbedRedirect /> },
    ],
  },
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          {
            element: <RequireReportingRole />,
            children: [
              { index: true, element: <ReportsIndexPage /> },
              { path: "reports/:slug", element: <ReportPage /> },
            ],
          },
        ],
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
